import MediaQuery from 'react-responsive';
import classNames from 'classnames';

import ComplainForm from '@components/ComplainForm';
import NModal from '@ui/Modal';
import { CreateComplaintMutationFn } from '@containers/ComplaintModalContainer/queries/graphql.v3.generated';
import { MEDIUM } from '@ui/mq';

// styles
import s from './ComplaintModal.sss';

// types
// TODO: Fix this the next time the file is edited.
 
type complaintType = {
  id: number,
  title: string,
};

type ComplaintModalProps = {
  refetch: (complaintId: { complaintId: number }) => void;
  types: complaintType[],
  initial: boolean
  allowComplain: (allow: boolean) => void,
  step: number,
  increaseStep: (counter: number) => void
  complaintId: number | null,
  setComplaintId: (complaintId: number | null) => void,
  userId: number,
  createComplaint: CreateComplaintMutationFn;
  productId?: number
  email: string | null | undefined
};

export const ComplaintModal: React.FC<ComplaintModalProps> = ({
  types,
  initial,
  allowComplain,
  refetch,
  step,
  increaseStep,
  complaintId,
  setComplaintId,
  userId,
  createComplaint,
  productId,
  email,
}) => {
  const closeModal = () => {
    allowComplain(false);
    increaseStep(1);
  };
  const closeSuccessModal = () => {
    allowComplain(false);
  };
  return (
    <>
      <MediaQuery maxWidth={MEDIUM - 1}>
        <NModal
          isOpen={initial}
          onRequestClose={step !== 4 ? closeModal : closeSuccessModal}
          className={classNames(s.root, s.mobile)}
          overlayClassName={s.overlay}
        >
          <ComplainForm
            types={types}
            refetch={refetch}
            step={step}
            increaseStep={increaseStep}
            complaintId={complaintId}
            setComplaintId={setComplaintId}
            userId={userId}
            createComplaint={createComplaint}
            closeModal={closeModal}
            closeSuccessModal={closeSuccessModal}
            isMobile={true}
            productId={productId}
            email={email}
          />
        </NModal>
      </MediaQuery>
      <MediaQuery minWidth={MEDIUM}>
        <NModal
          isOpen={initial}
          onRequestClose={step !== 4 ? closeModal : closeSuccessModal}
          className={classNames(s.root, step === 4 ? s.lastStep : '')}
        >
          <ComplainForm
            types={types}
            refetch={refetch}
            step={step}
            increaseStep={increaseStep}
            complaintId={complaintId}
            setComplaintId={setComplaintId}
            userId={userId}
            createComplaint={createComplaint}
            closeModal={closeModal}
            closeSuccessModal={closeSuccessModal}
            productId={productId}
            email={email}
          />
        </NModal>
      </MediaQuery>
    </>
  );
};

export default ComplaintModal;
